// extracted by mini-css-extract-plugin
module.exports = {"honer":"honor_honer__1AxbW","con":"honor_con__JWGMs","warp":"honor_warp__2_d8T","itm":"honor_itm__fezMP","img":"honor_img__zE98Q","dec":"honor_dec__1Dt2N","tet":"honor_tet__3fQ_z"};